export default {
  root: {
    class: [
      // Shape
      'shadow-lg',

      // Positioning
      'z-40 transform origin-center',
      'mt-1 absolute left-0 top-0',

      // Color
      'border',
      'border-white/5',
      'bg-surface-800',
      'text-surface-0/80'
    ]
  },
  content: {
    class: 'p-5 items-center flex'
  },
  icon: {
    class: 'text-2xl mr-4'
  },
  footer: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-end',
      'shrink-0',
      'text-right',
      'gap-2',

      // Spacing
      'px-6',
      'pb-6',

      // Shape
      'border-t-0',

      // Colors
      'bg-surface-800',
      'text-surface-0/80'
    ]
  },
  rejectbutton: {
    root: {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        'px-4 py-3 leading-none',

        // Color
        'text-primary-400',

        // States
        'hover:bg-primary-300/20',
        'focus:outline-hidden focus:outline-offset-0 focus:ring-3',
        'focus:ring-primary-300/50'
      ]
    }
  },
  acceptbutton: {
    root: {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        'px-4 py-3 leading-none',

        // Color
        'text-surface-900',
        'bg-primary-400',
        'border border-primary-400',

        // States
        'hover:bg-primary-300 hover:border-primary-300',
        'focus:outline-hidden focus:outline-offset-0 focus:ring-inset',
        'focus:ring-primary-300/50'
      ]
    }
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
